// Generated by ReScript, PLEASE EDIT WITH CARE


function map(dict, updater) {
  return Object.fromEntries(Object.entries(dict).map(function (param) {
                  return [
                          param[0],
                          updater(param[1])
                        ];
                }));
}

function addEntries(dict, values) {
  return Object.fromEntries(Object.entries(dict).concat(values));
}

export {
  map ,
  addEntries ,
}
/* No side effect */
